  export const DEFAULT_NOTICES = [
  { name: "Uniform and Dress Code Compliance", link: "/assets/notice/dresscode_circular.pdf", date: "Nov", day: "24" },
  { name: "Half Yearly Examination Form Circular", link: "/assets/notice/exam_form_circular.pdf", date: "Nov", day: "10" },
  { name: "Jac Exam Form Notification", link: "/assets/notice/inter_exam_form_jac.jpeg", date: "Nov", day: "15" },
  { name: "Intermediate Exam Form Fee 2026", link: "/assets/notice/EXAM_FORM_FEE_INT_2026.pdf", date: "Nov", day: "18" },
];

export const DEFAULT_GUIDELINES_ITEMS = [
   { name: "Uniform and Dress Code Compliance", link: "../../assets/notice/dresscode_circular.pdf", date: "Nov", day: "24" },
  { name: "Half Yearly Examination Form Circular", link: "../../assets/notice/exam_form_circular.pdf", date: "Nov", day: "10" }];


